export default "__VITE_ASSET__D6RXg232__"